import { useMemo } from 'react';

export const useIsStorybook = () => {
    const isStorybook = useMemo(() => {
        return (process.env['IS_STORYBOOK'] as string) ?? null;
    }, []);

    return { isStorybook };
};
